import * as React from "react";
import type { SVGProps } from "react";
interface SVGRProps {
  title?: string;
  titleId?: string;
  desc?: string;
  descId?: string;
}
const SvgSecurityIcon = ({
  title,
  titleId,
  desc,
  descId,
  ...props
}: SVGProps<SVGSVGElement> & SVGRProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    aria-hidden="true"
    data-slot="icon"
    width={24}
    height={24}
    aria-labelledby={titleId}
    aria-describedby={descId}
    {...props}
  >
    {desc ? <desc id={descId}>{desc}</desc> : null}
    {title ? <title id={titleId}>{title}</title> : null}
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="m9.375 11.5773 1.75 1.8188 3.9375-4.0922M19 12.032c0 4.4637-4.6847 7.7101-6.3893 8.7436-.1937.1175-.2905.1762-.4272.2067-.1061.0236-.2609.0236-.367 0-.1367-.0305-.2335-.0892-.4272-.2067C9.6847 19.7421 5 16.4957 5 12.032V7.683c0-.7271 0-1.0906.1144-1.4031.101-.276.2653-.5224.4786-.7177.2413-.221.5688-.3487 1.2238-.604l4.6916-1.8284c.1819-.071.2729-.1064.3665-.1204a.84.84 0 0 1 .2502 0c.0936.014.1846.0495.3665.1203l4.6915 1.8285c.6551.2553.9826.383 1.2239.604a1.82 1.82 0 0 1 .4786.7177C19 6.5924 19 6.9559 19 7.6829z"
    />
  </svg>
);
export default SvgSecurityIcon;
